import { render, staticRenderFns } from "./AccountsImport.vue?vue&type=template&id=f977295a&scoped=true&"
import script from "./AccountsImport.vue?vue&type=script&lang=js&"
export * from "./AccountsImport.vue?vue&type=script&lang=js&"
import style0 from "./AccountsImport.vue?vue&type=style&index=0&id=f977295a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f977295a",
  null
  
)

export default component.exports